/* =========================================================
   Dolls In Love — Seitenwechsel
   Beim Verlassen legt sich eine warme Blende über die Seite und der
   Inhalt sinkt leicht ab; beim Ankommen hebt er sich wieder heran.
   Wird eine Galeriekachel angeklickt, bleibt genau diese stehen —
   der Blick bleibt auf dem Modell, das man geöffnet hat.
   Nur opacity und transform, damit nichts neu gezeichnet wird.
   ========================================================= */
(function () {
  'use strict';
  const ruhig = window.matchMedia('(prefers-reduced-motion: reduce)');

  const blende = document.createElement('div');
  blende.className = 'blende';
  blende.setAttribute('aria-hidden', 'true');
  document.addEventListener('DOMContentLoaded', () => document.body.appendChild(blende));

  // Zurueck-Taste: nichts darf stehen bleiben
  window.addEventListener('pageshow', () => document.body.classList.remove('geht-fort'));

  document.addEventListener('click', e => {
    if (ruhig.matches) return;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    const a = e.target.closest('a[href]');
    if (!a || a.hasAttribute('download')) return;
    if (a.target && a.target !== '_self') return;
    if (a.closest('.hero__scene')) return;            // der Rahmen hat seinen eigenen Uebergang

    let u;
    try { u = new URL(a.getAttribute('href'), location.href); } catch (err) { return; }
    if (u.origin !== location.origin) return;
    if (/^\/(cart|checkout|account|apps|policies|admin)/.test(u.pathname) || /[?&](preview_theme_id|_ab)=/.test(u.search)) return;
    if (u.pathname === location.pathname && u.search === location.search) return;   // reiner Anker

    e.preventDefault();

    const kachel = a.classList.contains('tile') ? a : a.closest('.tile');
    if (kachel) kachel.classList.add('ist-gewaehlt');

    document.body.classList.add('geht-fort');
    setTimeout(() => { location.href = u.href; }, 560);
  });
})();
